var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading, rounded: "sm" } },
    [
      _c("b-form-select", {
        attrs: {
          options: _vm.options,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          size: _vm.size,
          "select-size": _vm.selectSize,
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.selectedValue,
          callback: function ($$v) {
            _vm.selectedValue = $$v
          },
          expression: "selectedValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }